<script lang="ts">
  import { getCustomSVG, hasImage } from '../../utils/image-library.js';

  export let id: string;
  export let size: number | string = 24;
  export let color: string | undefined = undefined;
  export let className: string = '';
  export let strokeWidth: number | undefined = undefined;

  $: sizeValue = typeof size === 'string' ? parseInt(size) : size;
  $: imageExists = hasImage(id);
  $: svgMarkup = imageExists ? getCustomSVG(id, sizeValue, color) : '';

  // Apply stroke width override and class if provided
  $: finalSvgMarkup = (() => {
    if (!svgMarkup) return '';
    let markup = svgMarkup;
    
    if (strokeWidth) {
      markup = markup.replace(/stroke-width="[^"]*"/g, `stroke-width="${strokeWidth}"`);
    }
    
    if (className) {
      // Add class attribute to the SVG element
      if (markup.includes('class=')) {
        markup = markup.replace(/class="([^"]*)"/, `class="$1 ${className}"`);
      } else {
        markup = markup.replace(/<svg/, `<svg class="${className}"`);
      }
    }
    
    return markup;
  })();
</script>

{#if imageExists}
  <span class="inline-flex items-center">{@html finalSvgMarkup}</span>
{:else}
  <span class="text-red-500" title={`Image "${id}" not found`}>
    [Missing: {id}]
  </span>
{/if}

<style>
  :global(svg) {
    display: inline-block;
    vertical-align: middle;
    color: inherit;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }
  
  /* Ensure SVG paths respect currentColor for stroke */
  :global(svg[stroke="currentColor"]) {
    color: inherit;
  }
</style>

